import FloorMap from './FloorMap';
export default FloorMap;
